import React, { useState, useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom';

import { reqGET,
    set_language,
	content_language,
} from '../../../Utils';

import { api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from './../../../UseToken';

import Loader from '../../Loader/Loader';

import { language } from './Language';

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);

    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(res => set_dados(res.data[0]))
            .catch(() => 404
                //  TODO: ENVIAR PÁGINA 404
                //  alert(error)); 
            );
    }

    useEffect(() => {

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')

        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);



    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            
            <Loader />

            :
            
            <main>

                <div className={`dash-cards header`}>
                    <h2 className="dash-title">{language[lang].entity}</h2>
                    <p>{language[lang].component} </p>
                </div>

                <div className={`dash-cards body`}>
                    <div className='container'>
                        <div className='row'>
            
                            <div className="mb-5 mb-xl-10">
                                <div className='card'>


                                    <div id="div-content">

                                        <div className="card-body border-top p-4">
                                            <div className='tab-content'>

                                                <div className='col-12 col-md-4 my-3'>
                                                    <label className="col-form-label fs-6 fw-bold">{language[lang].name}</label>
                                                    <p>{dados.info.name !== '' ? dados.info.name : 'Desconhecido'}</p>
                                                </div>
                                                <div className='col-12 col-md-4 my-3'>
                                                    <label className="col-form-label fs-6 fw-bold">{language[lang].username_email}</label>
                                                    <p>{dados.info.username}</p>
                                                </div>
                                                <div className='col-12 col-md-4 my-3'>
                                                    <label className="col-form-label fs-6 fw-bold">{language[lang].contact_email}</label>
                                                    <p>{dados.info.email}</p>
                                                </div>



                                                { 
                                                    dados.contacts[0].mobile_phone !== undefined && dados.contacts[0].mobile_phone !== '' ?
                                                        <div className='col-12 col-md-3 my-3'>
                                                            <label className="col-form-label fs-6 fw-bold">Contacto</label>
                                                            <p>{dados.contacts[0].mobile_phone}</p>
                                                        </div>
                                                    : null
                                                }

                                                { 
                                                    dados.info.nif !== '' ?
                                                        <div className='col-12 col-md-3 my-3'>
                                                            <label className="col-form-label fs-6 fw-bold">NIF</label>
                                                            <p>{dados.info.vat}</p>
                                                        </div>
                                                    : null
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className={'dash-cards-2 footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">

                            <ul className="navbar-nav float-left"></ul>

                            <ul className="navbar-nav float-right">

                                <li className="nav-item">
                                    <Link className="nav-link btn-cancel" to={{ pathname: (endpoints.list) }} replace>
                                        <img alt='' src={'./img/seta_2.svg'} />
                                        <span>{language[lang].back}</span>
                                    </Link>
                                </li>

                            </ul>

                        </div>
                    </nav>
                </div>
                
            </main>
}